import { render, staticRenderFns } from "./Piano.vue?vue&type=template&id=97911ffe&scoped=true&lang=pug"
import script from "./Piano.vue?vue&type=script&lang=js"
export * from "./Piano.vue?vue&type=script&lang=js"
import style0 from "./Piano.vue?vue&type=style&index=0&id=97911ffe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97911ffe",
  null
  
)

export default component.exports